/**
 * Background variant type for hero components and breadcrumbs.
 * Represents the background color, which determines text color:
 * - LIGHT: Light background → dark text
 * - DARK: Dark background → light text
 */
export const BackgroundVariant = {
    LIGHT: 'light',
    DARK: 'dark',
} as const;

export type BackgroundVariant = (typeof BackgroundVariant)[keyof typeof BackgroundVariant];

/**
 * @deprecated Use `BackgroundVariant` instead. This will be removed in a future version.
 * Namespace required for backward compatibility to allow both value and type usage
 *
 * TODO: Remove VariantType namespace and type in next major version
 * - Remove namespace export
 * - Remove type export
 * - Update all usages to use BackgroundVariant directly
 * - Check for usages: `grep -r "VariantType" libs/`
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace VariantType {
    export const LIGHT = BackgroundVariant.LIGHT;
    export const DARK = BackgroundVariant.DARK;
    /** @deprecated Use LIGHT instead */
    export const DEFAULT = BackgroundVariant.LIGHT;
}

export type VariantType = BackgroundVariant;
